import React from 'react';
import ArrowLink from '@boschebike/ebds-react/dist-esm/components/ArrowLink.js';
import { BoschIconAsChunk } from '../../ebds/iconProvider.js';

/**
 * @typedef {import('../../App.d.ts').ServiceFeatureOverviewItemProps} ServiceFeatureOverviewItemProps
 */
/**
 * @param {ServiceFeatureOverviewItemProps} props
 */
export default (props) => {
  return (
    <div
      data-testid="service-feature-overview-item"
      className="service-feature-overview__item"
    >
      <span className="service-feature-overview__item__icon">
        <BoschIconAsChunk iconName={props.icon} />
      </span>
      <h6 className="service-feature-overview__item__headline">{props.subheadline}</h6>
      <div className="service-feature-overview__item__copy-text">{props.headline}</div>
      <div className="service-feature-overview__item__cta-position">
        {props.button ? (
          <ArrowLink
            text={props.button.label}
            href={props.button.href}
          />
        ) : (
          <span className="not-available">Available soon</span>
        )}
      </div>
    </div>
  );
};
